import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PlanFilters = ({ filters, onChange }) => {
  const durationOptions = [
    { value: 'all', label: 'All Durations' },
    { value: 'short', label: 'Short (≤30 days)' },
    { value: 'medium', label: 'Medium (31-180 days)' },
    { value: 'long', label: 'Long (180+ days)' }
  ];

  const typeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'chronological', label: 'Chronological' },
    { value: 'thematic', label: 'Thematic' },
    { value: 'devotional', label: 'Devotional' },
    { value: 'custom', label: 'Custom' }
  ];

  const hasActiveFilters = filters?.duration !== 'all' || filters?.type !== 'all';

  const handleClearFilters = () => {
    onChange('duration', 'all');
    onChange('type', 'all');
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center">
      {/* Filter Selects */}
      <div className="flex flex-wrap gap-3">
        <Select
          value={filters?.duration}
          onValueChange={(value) => onChange?.('duration', value)}
          options={durationOptions}
          placeholder="Duration"
        />
        
        <Select
          value={filters?.type}
          onValueChange={(value) => onChange?.('type', value)}
          options={typeOptions}
          placeholder="Type"
        />
      </div>

      {/* Clear Filters */}
      {hasActiveFilters && (
        <Button
          variant="ghost"
          size="sm"
          onClick={handleClearFilters}
          className="text-muted-foreground hover:text-foreground"
        >
          <Icon name="X" size={14} />
          Clear
        </Button>
      )}
    </div>
  );
};

export default PlanFilters;